import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { IUserRepository } from './Iuser.repository';
import { ApiResponse, Dictionary, UserLastSignIn, UserProfile } from './models';


@Injectable({ providedIn: 'root' })
export class UserRepository implements IUserRepository {

	constructor(private readonly httpClient: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }


	// USER API - USERS
	editUser(profile: UserProfile): Observable<ApiResponse<any>> {
		return this.httpClient.put<ApiResponse<any>>(this.config.domainUserAPI + '/api/users/EditUser', profile);
	}
	getUserGuid(username: string): Observable<ApiResponse<string>> {
		const params = new HttpParams().set('username', username);
		return this.httpClient.get<ApiResponse<string>>(this.config.domainUserAPI + '/api/users/GetUserGuid', { params: params });
	}
	getUserProfile(): Observable<ApiResponse<UserProfile>> {
		return this.httpClient.get<ApiResponse<UserProfile>>(this.config.domainUserAPI + '/api/users/GetUserProfile');
	}
	getLastSignIn(userId: string): Observable<ApiResponse<UserLastSignIn>> {
		const params = new HttpParams().set('userId', userId);
		return this.httpClient.get<ApiResponse<UserLastSignIn>>(this.config.domainUserAPI + '/api/users/LastSignIn', { params });
	}
	changeLanguage(languageCode: string): Observable<ApiResponse<void>> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.httpClient.patch<ApiResponse<void>>(this.config.domainUserAPI + '/api/users/ChangeUserLanguage', `"${languageCode}"`, { headers: headers });
	}
	getLanguages(): Observable<ApiResponse<string[]>> {
		return this.httpClient.get<ApiResponse<string[]>>(this.config.domainUserAPI + '/api/users/GetLanguages');
	}
	getApplicationUrl(): Observable<ApiResponse<string>> {
		return this.httpClient.get<ApiResponse<string>>(this.config.domainUserAPI + '/api/users/ApplicationUrl');
	}

	// ADMIN API - REQUEST

	getDictionaries(dictionaryList: string): Observable<ApiResponse<Dictionary[]>> {
		const params = new HttpParams().set('nameList', dictionaryList);
		return this.httpClient.get<ApiResponse<Dictionary[]>>(this.config.domainAdminAPI + '/api/request/Dictionaries', { params: params });
	}
}
